import type { SVGProps } from "react";
export interface MessageEllipsisIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MessageEllipsisIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MessageEllipsisIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 6c0-1.036-.84-1.875-1.875-1.875H5c-1.036 0-1.875.84-1.875 1.875v10c0 1.036.84 1.875 1.875 1.875h2c.62 0 1.125.504 1.125 1.125v1.77l3.534-2.25a4.13 4.13 0 0 1 2.215-.645H19c1.035 0 1.874-.84 1.875-1.875zm2.25 10A4.125 4.125 0 0 1 19 20.125h-5.126c-.268 0-.531.056-.773.166l-.233.128L9.14 22.79c-1.414.9-3.266-.115-3.266-1.791v-.873H5A4.125 4.125 0 0 1 .875 16V6A4.125 4.125 0 0 1 5 1.875h14A4.125 4.125 0 0 1 23.125 6z"
      />
      <path
        fill={color}
        d="M16 10.629a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm1 .741a.6.6 0 0 0 .112-.244l.013-.127-.013-.126A.6.6 0 0 0 17 10.63v.741Zm-4.388-.496a.6.6 0 0 0-.111-.245v.741a.6.6 0 0 0 .11-.244l.014-.127-.013-.126Zm-1.112-.245a.62.62 0 0 0-.124.37l.011.127c.019.09.06.172.113.244zm-3.388.245A.6.6 0 0 0 8 10.629v.741a.6.6 0 0 0 .112-.244l.013-.127-.013-.126ZM7 10.629a.62.62 0 0 0-.125.37l.012.127c.019.09.06.172.113.244zm2.125.37a1.625 1.625 0 0 1-3.242.167L5.876 11l.009-.165A1.625 1.625 0 0 1 7.5 9.375l.167.009a1.623 1.623 0 0 1 1.458 1.615m4.5 0a1.625 1.625 0 0 1-3.242.167L10.376 11l.009-.165A1.625 1.625 0 0 1 12 9.376l.167.009c.82.083 1.46.774 1.46 1.615Zm4.5 0a1.625 1.625 0 0 1-3.242.167L14.876 11l.009-.165a1.625 1.625 0 0 1 1.615-1.46l.166.009c.82.083 1.46.774 1.46 1.615Z"
      />
    </svg>
  );
}
